<div class="status-bar" [ngClass]="statusBarClass" appDataCy="toast"></div>
<div class="flex-row gap-16" [fxLayoutAlign]="canShowActionButton() ? 'space-between top' : 'space-between center'">
  <mat-icon [svgIcon]="titleIcon" class="message-icon"></mat-icon>
  <div class="content flex">
    @if (title) {
      <div class="font-weight-semibold">{{ title | bmsTranslate }}</div>
    }
    <div class="message" [innerHTML]="message"></div>
    @if (canShowActionButton()) {
      <div class="toolbar">
        <button mat-flat-button (click)="triggerAction()">{{ buttonText | bmsTranslate }}</button>
      </div>
    }
  </div>
  <mat-icon svgIcon="close" class="delete-icon" (click)="dismiss()" appDataCy="toast-delete-button"></mat-icon>
</div>
